import { Crown } from "lucide-react";

// Permanent "Founding Member" recognition badge.
export function FoundingBadge({ className = "" }) {
  return (
    <span
      data-testid="founding-badge"
      className={`inline-flex items-center gap-1.5 rounded-full bg-amber-400 text-amber-950 ring-1 ring-amber-500/50 text-xs font-bold tracking-wide px-3 py-1 ${className}`}
    >
      <Crown className="w-3.5 h-3.5" /> Founding Member
    </span>
  );
}
